/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * ListNumberedIcon
 */
export default class ListNumberedIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M5.623 16.89c.524 0 .802.595.506.994l-.063.072-.928.933.074.029c.192.082.365.198.52.349l.112.119c.95 1.103.181 2.715-1.086 2.919-.861.138-1.65-.184-2.25-.954a.625.625 0 11.985-.768c.324.415.662.553 1.067.487.362-.058.602-.56.336-.869-.178-.206-.502-.261-1.079-.1-.587.166-1.02-.513-.673-.971l.061-.07.914-.92h-.942a.625.625 0 01-.618-.532l-.007-.093c0-.314.232-.573.533-.618l.092-.007h2.446zM22 18a1 1 0 01.117 1.993L22 20H10a1 1 0 01-.117-1.993L10 18h12zM4.222 8.897c.573 0 .994.12 1.381.46.694.613.943 1.64.22 2.699-.223.327-.485.6-.935 1.002l-.705.625-.108.1h1.704c.314 0 .574.232.619.533l.006.092a.625.625 0 01-.532.619l-.093.006H3a.625.625 0 01-.625-.625c0-.388.159-.742.44-1.096l.145-.175c.129-.146.271-.283.55-.53l.666-.59c.301-.276.48-.469.615-.666.329-.481.245-.827-.015-1.056-.124-.11-.258-.148-.554-.148-.317 0-.597.36-.597.853a.625.625 0 11-1.25 0c0-1.125.761-2.103 1.847-2.103zM22 11a1 1 0 01.117 1.993L22 13H10a1 1 0 01-.117-1.993L10 11h12zM4.272 1.709c.314 0 .573.231.618.533l.007.092V6.59a.625.625 0 01-1.243.093l-.007-.093-.001-3.133-.589.504a.625.625 0 01-.809.002l-.072-.072a.625.625 0 01-.002-.809l.072-.072L3.594 1.86c.09-.078.2-.127.318-.144L4 1.71h.272zM22 4a1 1 0 01.117 1.993L22 6H10a1 1 0 01-.117-1.993L10 4h12z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

